import { db } from "config/firebase";
import { createHash } from "utils/helperFunctions";
import { doc, getDoc, updateDoc } from "firebase/firestore";

const addPlayerToGame = async (
  gameId: string,
  playerData: any,
  expTime: number,
): Promise<void> => {
  const gameRef = doc(db, "games", gameId);

  const updatedPlayerData = { ...playerData, timeStamp: expTime };

  try {
    const docSnap = await getDoc(gameRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      const { currentPlayers } = data;
      const { playerlist } = data;
      currentPlayers[updatedPlayerData.id] = true;
      playerlist[updatedPlayerData.id] = updatedPlayerData;

      await updateDoc(gameRef, { playerlist, currentPlayers });
    }
  } catch (err) {
    console.warn(err);
  }
};

const removePlayerFromGame = async (
  gameId: string,
  playerId: string,
): Promise<any> => {
  const gameRef = doc(db, "games", gameId);

  try {
    const docSnap = await getDoc(gameRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      const { currentPlayers } = data;
      const { playerlist } = data;

      delete currentPlayers[playerId];
      delete playerlist[playerId];

      await updateDoc(gameRef, {
        currentPlayers,
        playerlist,
      });
    }
  } catch (err) {
    return err;
  }
};

const addPlayerToTableManually = async (
  gameId: string,
  playerName: string,
): Promise<{ msg: string }> => {
  if (playerName === "") {
    return { msg: "Please enter a name" };
  }
  const gameRef = doc(db, "games", gameId);
  const id = `Host${createHash(playerName)}`;
  const playerData = {
    id,
    displayName: `${playerName} (Guest)`,
    manuallyAdded: true,
    timeStamp: Date.now(),
  };

  try {
    const docSnap = await getDoc(gameRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      const { currentPlayers, playerlist } = data;

      if (currentPlayers[id]) {
        return { msg: "Player is already on the table" };
      }
      
      const updatedCurrentPlayers = { ...currentPlayers, [id]: true };
      const updatedPlayerlist = { ...playerlist, [id]: playerData };
      await updateDoc(gameRef, { currentPlayers: updatedCurrentPlayers, playerlist: updatedPlayerlist });
      return { msg: "Player added to table successfully" };
    }
    return { msg: "Game not found" };
  } catch {
    return { msg: "Error adding player" };
  }
};

const confirmAddPlayer = async (
  gameId: string,
  playerId: string,
): Promise<any> => {
  const gameRef = doc(db, "games", gameId);

  try {
    const docSnap = await getDoc(gameRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      const { playerlist } = data;
      playerlist[playerId] = { ...playerlist[playerId], timeStamp: Date.now() };

      await updateDoc(gameRef, { playerlist });
    }
  } catch (err) {
    console.log("error confirming player", err);
    return err;
  }
};

const declineJoinGame = async (
  gameId: string,
  playerId: string,
): Promise<any> => {
  const gameRef = doc(db, "games", gameId);

  try {
    const docSnap = await getDoc(gameRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      const { currentPlayers, playerlist } = data;
      delete currentPlayers[playerId];
      delete playerlist[playerId];

      await updateDoc(gameRef, {
        currentPlayers,
        playerlist,
      });
    }
  } catch (err) {
    return err;
  }
};

export default {
  addPlayerToGame,
  removePlayerFromGame,
  addPlayerToTableManually,
  confirmAddPlayer,
  declineJoinGame,
};
